import { array, struct } from 'io-ts/lib/Decoder';

import { EqualsType } from '../../api/generic/search/filter';
import { Id as JobTypeId } from '../../job/job-type';

export const JobType = struct({
	equalsType: EqualsType,
	values: array(JobTypeId),
});
